module.exports = __webpack_public_path__ + "media/1x1/fr-f8952213.svg";